<template>
  <div class="setting-main-container">
    <form action="" @submit.prevent="submitBusinessData">
      <div class="card setting-card">
        <div class="page-header">
          <h3 class="page-title">{{ $t('profile.business_nature.business_nature') }}</h3>
          <p class="page-sub-title">
            {{ $t('profile.business_nature.section_description') }}
          </p>
        </div>
        <div class="row">
         
          <div class="col-md-12 mb-4">
            <label class="input-label">{{ $tc('profile.business_nature.business_nature') }}</label><span class="text-danger"> * </span>
            <base-text-area
                v-model="formData.nature"   
                @input="$v.formData.nature.$touch()"     
            />
            <div v-if="$v.formData.nature.$error">
              <span v-if="!$v.formData.nature.required" class="text-danger">{{ $tc('validation.required') }}</span>
              <span v-if="!$v.formData.nature.maxLength" class="text-danger">{{ $tc('validation.nature_maxlength') }}</span>
            </div>
          </div>
              
        </div>
        <div class="row">
          <div class="col-md-12">
            <base-button
              :loading="isLoading"
              :disabled="isLoading"
              icon="save"
              color="theme"
              type="submit"
            >
              {{ $tc('profile.business_status.save') }}
            </base-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import IconUpload from '../../components/icon/upload'
import { validationMixin } from 'vuelidate'
import { mapActions,mapGetters } from 'vuex'
const { required, email, maxLength } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data () {
    return {
      formData: {
          id:null,  
          nature: null,
      },
      isLoading: false,
    }
  },
   computed: {
    ...mapGetters('business', [
      'business'
    ]),
   },
    created() {
      if(this.business){
        this.formData.id=this.business.id
      }  
      if(this.business && this.business.nature){
        this.formData.nature=this.business.nature
      }
    },
  validations: {
    formData: {
      nature: {
        required,
        maxLength: maxLength(255)
      },
    }
  },
  mounted () {
    
  },
  methods: {
    ...mapActions('business', [
      'addBusiness',
      'updateBusiness'
    ]),  
    async submitBusinessData(){
        this.$v.formData.$touch()
        if (this.$v.$invalid) {
            return true
        }
        let  response = await this.addBusiness(this.formData)
        if (response.data) { 
            this.isLoading = false
            window.toastr['success'](this.$tc('profile.business_nature.saved_message'))
            return true
        }
    }
  }
}
</script>
